/* eslint-disable react/require-default-props */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/jsx-indent */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
import {
  MdSearch,
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdRadioButtonChecked,
  MdRadioButtonUnchecked,
} from 'react-icons/md';

import { Button } from '@material-ui/core';
import { useDebounce } from 'use-debounce';

import colors from '~/styles/colors';

import {
  Container,
  FooterContainer,
  ContentFooter,
  ContainerInputSearch,
} from './styles';

interface Option {
  id?: string;
  label?: string;
}

type Props = {
  values: Option[] | null;
  optionsData: Option[];
  onSubmit: (values: Option[]) => void;
  isMulti?: boolean;
  onOpenModal: (open: boolean) => void;
  onFilterOptions: (search: string) => Array<Option>;
};

function DataListSync({
  values,
  onSubmit,
  optionsData,
  onOpenModal,
  onFilterOptions,
  isMulti = false,
}: Props): JSX.Element {
  const [selectedOptions, setSelectedOptions] = useState<Array<Option>>([]);
  const [search, setSearch] = useState<string>('');
  const [searchDebounce] = useDebounce(search, 800);
  const [options, setOptions] = useState<Array<Option>>([]);

  const hasThisOption = (id?: string): boolean => {
    return (
      selectedOptions.length > 0 &&
      !!selectedOptions.find((option) => option.id === id)
    );
  };

  const handleAddOption = (selectedValue: Option) => {
    const newSelectedOptions = selectedOptions.filter(
      ({ id }) => id !== selectedValue.id,
    );
    setSelectedOptions(
      hasThisOption(selectedValue.id)
        ? [...newSelectedOptions]
        : [...newSelectedOptions, selectedValue],
    );
  };

  const handleAddSingleOption = (incomingOption: Option) => {
    setSelectedOptions([incomingOption]);
  };

  const handleSubmit = () => {
    onSubmit(selectedOptions);
    onOpenModal(false);
  };

  useEffect(() => {
    setOptions(optionsData);
  }, [optionsData]);

  useEffect(() => {
    setSelectedOptions(values || []);
  }, [values]);

  useEffect(() => {
    const filteredOptions = onFilterOptions(searchDebounce);

    setOptions(filteredOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDebounce]);

  return (
    <Container>
      <ContainerInputSearch>
        <MdSearch size={25} />
        <input
          aria-label="search-input"
          id="search-input"
          type="text"
          placeholder="Buscar dados"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </ContainerInputSearch>

      <ul>
        <div
          style={{
            paddingRight: '15px',
            height: '210px',
            overflowY: 'auto',
          }}
        >
          {options.length > 0 &&
            options.map((option) => (
              <li
                key={option.id}
                role="button"
                onClick={
                  isMulti
                    ? () => handleAddOption(option)
                    : () => handleAddSingleOption(option)
                }
              >
                {isMulti ? (
                  hasThisOption(option.id) ? (
                    <MdCheckBox size={24} color={colors.primary} />
                  ) : (
                    <MdCheckBoxOutlineBlank
                      onClick={() => handleAddOption(option)}
                      size={24}
                      color="#b4b4b4"
                    />
                  )
                ) : (
                  <>
                    {hasThisOption(option.id) ? (
                      <MdRadioButtonChecked size={24} color={colors.primary} />
                    ) : (
                      <MdRadioButtonUnchecked
                        size={24}
                        color="#b4b4b4"
                        onClick={() => handleAddSingleOption(option)}
                      />
                    )}
                  </>
                )}
                <label htmlFor="dataList">{option.label}</label>
              </li>
            ))}
          {options.length === 0 &&
            'Sua pesquisa está correta? Não encontramos informações :('}
        </div>
      </ul>

      <FooterContainer>
        <ContentFooter>
          <Button
            type="button"
            disabled={false || !selectedOptions}
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ width: '100%' }}
          >
            Confirmar seleção
          </Button>
        </ContentFooter>
      </FooterContainer>
    </Container>
  );
}

export default DataListSync;
